module.exports = __webpack_public_path__ + "static/img/tmmnzl-logo.e5bfdb71.png";